import { PoweredBy } from "./PoweredBy";

type Props = {
  onDownload: () => void;
};

export function Completion({ onDownload }: Props) {
  return (
    <div className="completion">
      <div
        className="hero"
        aria-hidden="true"
        style={{
          width: 96,
          height: 96,
          borderRadius: 24,
          background: "var(--primary)",
          color: "var(--submit)",
          margin: "0 auto 20px",
          display: "grid",
          placeItems: "center",
          fontSize: 44,
        }}
      >
        ✓
      </div>
      <h1>Application received</h1>
      <p style={{ color: "var(--muted)" }}>
        Thanks so much for applying to be an Upside mentor. We'll review your application and be in touch about next steps.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "center", marginTop: 24 }}>
        <button className="btn btn-primary" onClick={onDownload}>
          Download a copy of your responses
        </button>
        <a href="https://upside.org.nz" rel="noopener noreferrer" style={{ fontSize: 14 }}>
          Back to upside.org.nz
        </a>
      </div>
      <PoweredBy />
    </div>
  );
}
